import React from 'react'
import { useDarkmodeContext } from '../contexts/DarkmodeContext';

function Spinner() {
    const { darkMode } = useDarkmodeContext()

    return (
        <div className={`spinner-container ${darkMode && 'dark'}`}>
            <div className="loadingio-spinner-bean-eater-8zn0g2zn94e"><div className="ldio-usidey6wd2">
                <div><div></div><div></div><div></div></div><div><div></div><div></div><div></div></div>
            </div></div>
        </div>
    )
}

export default Spinner;
